// This is a part of the Cadcorp SIS source code. 
// Copyright (c) Cadcorp Limited 1991-2026 
import { IProfileMap, IProfileState, IRootState } from '../../../../CommonScripts/Abstractions';
import { Module } from 'Vuex';
import Vue from 'Vue';
const theState: IProfileState = {
    name: null,
    maps: null,
    canLogout: null,
    canEditProfile: null,
    showMapSwitcher: null
};
const profileState: Module<IProfileState, IRootState> = {
    namespaced: true,
    state: theState,
    mutations: {
        setName(state, name: string) {
            state.name = name;
        },
        setMaps(state, maps: IProfileMap[]) {
            state.maps = maps;
        },
        setCanLogout(state, canLogout: boolean) {
            state.canLogout = canLogout;
        },
        setCanEditProfile(state, canEditProfile: boolean) {
            state.canEditProfile = canEditProfile;
        },
        setShowMapSwitcher(state, showMapSwitcher: boolean) {
            state.showMapSwitcher = showMapSwitcher;
        }
    }
}
export default profileState;

